module.exports = __webpack_public_path__ + "static/media/2_PoA-uchastie-OSA_20160622.a180ba05.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/2_PoA-uchastie-OSA_20160622.pdf
// module id = 165
// module chunks = 0